var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPastAgendaEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.695 46.839c12.174 0 22.047-9.799 22.047-21.898 0-12.1-9.873-21.899-22.047-21.899-12.174 0-22.047 9.799-22.047 21.898 0 12.1 9.873 21.899 22.047 21.899Z",
    fill: "#F5F5F7",
    stroke: "#DDDEE5",
    strokeWidth: 0.834,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.583 22.084v13.398c0 2.784-2.264 5.048-5.085 5.048H14.967a5.077 5.077 0 0 1-5.085-5.01V22.009c0-.074 0-.148.037-.223.037-.11.074-.185.111-.296l6.31-12.063c.223-.483.705-.742 1.225-.742h18.298c.52 0 .965.26 1.225.742l6.31 12.063c.037.074.074.185.111.297.074.074.074.185.074.297Z",
    fill: "#F5F5F7",
    stroke: "#DDDEE5",
    strokeWidth: 0.834,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.906 3.81c.484 5.288.727 6.498-.37 11.287-.357 1.065-.714 2.231-1.478 3.043-1.07 1.267-3.006 1.825-4.585 1.42-1.63-.406-2.955-1.826-3.261-3.55-.255-1.065.102-2.332 1.019-2.991.968-.608 2.344-.456 3.159.304.917.76 1.274 1.927 1.223 3.042-.051 1.115-.459 2.23-1.02 3.194-1.266 2.369-1.788 2.36-4.381 6.25",
    stroke: "#AAAEBE",
    strokeWidth: 0.834,
    strokeMiterlimit: 10,
    strokeDasharray: "1.67 1.67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.747 1.84c-.194.706-.968.963-1.743.513-.84-.385-1.42-.706-1.291-1.349.194-.642.968-.706 1.872-.77 1.097-.129 1.291.899 1.162 1.606ZM32.484 2.482c.323.578 1.227.964 1.873.386.71-.643 1.29-1.092.968-1.735-.323-.578-.84-.385-1.937-.257-.904.193-1.29.964-.904 1.606Z",
    fill: "#D4D6DE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.325.106c.452-.065.904.192 1.033.578.064.128.129.32.129.45.13.899-.194 1.67-.71 1.734-.581.128-1.162-.514-1.227-1.35V.942c.065-.45.323-.771.775-.835 0 0 .064 0 0 0Z",
    fill: "#CCCED8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.583 22.082v14.772c0 2.042-1.633 3.675-3.711 3.675H13.593c-2.04 0-3.711-1.633-3.711-3.675V22.008c0-.074 0-.149.037-.223h8.462a2.289 2.289 0 0 1 2.302 2.301c0 .631.26 1.225.668 1.634.445.445.965.668 1.633.668h7.534a2.289 2.289 0 0 0 2.302-2.302c0-.63.26-1.224.668-1.633a2.159 2.159 0 0 1 1.596-.668h8.425c.074.074.074.186.074.297Z",
    fill: "#fff",
    stroke: "#DDDEE5",
    strokeWidth: 0.834,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.497 31.346a.852.852 0 1 0 0-1.704.852.852 0 0 0 0 1.704ZM30.967 31.346a.852.852 0 1 0 0-1.703.852.852 0 0 0 0 1.703ZM28.113 36.938h-2.67a.766.766 0 0 1-.759-.76c0-.414.345-.76.76-.76h2.646c.415 0 .76.346.76.76a.732.732 0 0 1-.737.76Z",
    fill: "#CCCED8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.179 14.475a1.522 1.522 0 1 0 0-3.043 1.522 1.522 0 0 0 0 3.043ZM46.657 9.537a1.04 1.04 0 1 0 0-2.078 1.04 1.04 0 0 0 0 2.078ZM4.568 12.951a1.04 1.04 0 1 0 0-2.078 1.04 1.04 0 0 0 0 2.079ZM2.23 35.816a1.93 1.93 0 1 0 0-3.86 1.93 1.93 0 0 0 0 3.86Z",
    fill: "#F5F5F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastAgendaEmpty);
export default __webpack_public_path__ + "static/media/past-agenda-empty.7784a004ea741e9dbd2ea216f1a854e3487901088fe0ae2d3708049d4965991b.svg";
export { ForwardRef as ReactComponent };